export const getCompanyByType = (companies, type) => {
  return companies.find(c => {
    const { companyType: legacyCompanyType, companyTypes } = c.company.currentVersion;
    const companyTypesToSearch = [
      legacyCompanyType || null,
      ...(companyTypes || []),
    ].filter(s => s);
    const companyType = companyTypesToSearch.find(ct => ct.currentVersion.name === type);
    if (!companyType) {
      return false;
    }

    if (c.companyTypeId) {
      return c.companyTypeId === companyType.id;
    }

    return true;
  });
};
